<template>
  <el-table :data="credits" style="100%" ref="summary" :cell-style="{padding:'4px'}" stripe header-row-class-name="fs-12">
    <el-table-column :label="$t('credit_notes.date')" prop="date">
      <template slot-scope="scope">
        <span>{{_moment(scope.row.date)}}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('credit_notes.creditNoteNumber')" prop="crNumber">
      <template slot-scope="scope">
        <PortausLink :id="scope.row.id" :label="scope.row.crNumber" path="/credit-notes/" :underline="true"></PortausLink>
      </template>
    </el-table-column>
    <el-table-column :label="$t('credit_notes.customer')" v-if="showCustomer">
      <template slot-scope="scope">
        <PortausLink :id="scope.row.customer.id" :label="customerName(scope.row.customer.name,scope.row.customer.usual_name)" path="/customers/" :underline="true"></PortausLink>
      </template>
    </el-table-column>
    <el-table-column :label="$t('credit_notes.status')">
      <template slot-scope="scope">
        <el-tag :type="getInvoiceTagType(scope.row.status)" style="margin-left:10px;"> {{$t("credit_notes.statuses."+scope.row.status.code)}}</el-tag>
      </template>
    </el-table-column>
    <el-table-column :label="$t('credit_notes.issuedAt')">
      <template slot-scope="scope">
        {{$n(scope.row.total,'currency',scope.row.currency.code)}}
      </template>
    </el-table-column>
    <el-table-column :label="$t('credit_notes.creditUsed')">
      <template slot-scope="scope">
        {{$n(scope.row.balance.paid,'currency',scope.row.currency.code)}}
      </template>
    </el-table-column>
    <el-table-column :label="$t('credit_notes.remainingCredit')">
      <template slot-scope="scope">
          {{$n(scope.row.balance.outstanding,'currency',scope.row.currency.code)}}
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import moment from 'moment'
import { mapActions, mapState, mapGetters } from 'vuex';
import PortausLink from '@/components/portaus-link'
import CustomerUtil from '@/utils/customer-util'
export default {
	name: 'Credits-summary',
  props : {
    credits : {
        type : Array,
        default : () => []
      },
    showCustomer : {
      type : Boolean,
      default : true
    }
  },
  data() {
    return {

    };
  },
  methods : {
    customerName(name, usual_name){
      return CustomerUtil.customerName(name, usual_name);
    },
    _moment(date, format='l'){
      return moment(date).format(format);
    }
  },
	computed : {
    ...mapGetters('invoices',['getInvoiceTagType'])
	},
	components : {
    PortausLink
	}
}
</script>
